import { RefundableState } from '../enum/RefundableState';

export const refundableStateTranslationMap: { [value in RefundableState]: string } = {
  [RefundableState.REFUNDABLE]: 'trans__configurator__customise_page_summary_section__reservation_fee_fully_refundable',
  [RefundableState.NON_REFUNDABLE]:
    'trans__configurator__customise_page_summary_section__reservation_fee_non_refundable',
  [RefundableState.PARTIALLY_REFUNDABLE]:
    'trans__configurator__customise_page_summary_section__reservation_fee_partially_refundable',
};
